export enum LogoNames {
    // Intigrity assured image
    IA = 'IA_Color.png',
    // Joint assured image
    JA = 'JA_Color.png',
    // project assured image
    PA = 'PA_Color.png',
    CA = 'CA_Color_c.png',
}
